//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: absolute;
    bottom: 105%;
    left: 0;
    background-color: var(--light-blue-2);
`;
export const Text = styled.span`
    color: var(--light-gray-5);
    text-align: center;
    font-size: 12px;
`;